<template>
  <div>
    <grouped-bar-chart style="position: relative; height:220px" :data="this.groupedBarChartData"
                       :options="this.groupedBarChartOptions"
                       v-if="this.groupedBarChartData && this.groupedBarChartData.datasets && this.groupedBarChartData.datasets.length > 0"></grouped-bar-chart>
    <v-sheet height="200px" class="text-center d-flex align-center justify-center" v-else>
      <slot>No data to display</slot>
    </v-sheet>
  </div>
</template>

<script>
  import GroupedBarChart from "../Wrappers/groupedBarChart";
  import {jobOffersColors} from "../../../constants/constants";

  export default {
    name: "jobOffersPerWeekBars",
    components: {GroupedBarChart},
    props: ['histogram'],
    data(){
      return {
        groupedBarChartData: {},
        groupedBarChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top"
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: true,
                color: '#eee'
              },
            }],
            yAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                beginAtZero: true
              }
            }]
          },
        },
      }
    },
    watch: {
      histogram: function (newVal, oldVal) {
        this.groupedBarChartData = this.composeGroupedBarChartData();
      }
    },
    methods: {
      composeGroupedBarChartData() {

        let timeMarks = [];
        // let datasets = this.profile.edges.jobs.stats.map((e, i) => {
        //   e.keywordsPerWeek.forEach(e => {
        //     timeMarks.push({ week: e.week, year: e.year})
        //   });
        //   return {
        //     label: e._id,
        //     data: e.keywordsPerWeek.sort((a,b) => a.year > b.year ? 1 : (b.week > a.week ? -1 : 0)).map(e => e.count),
        //     backgroundColor: jobOffersColors[i]
        //   }
        // });

        this.histogram.forEach((e, i) => {
          e.jobSearchTermsPerWeek.forEach(e => {
            timeMarks.push({ week: e.week, year: e.year})
          });
        });

        timeMarks = timeMarks
          .filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.week === value.week && t.year === value.year
            ))
          )
          .sort((a,b) => (a.year*100 + a.week - b.year*100 - b.week));

        let datasets = [];
        this.histogram.forEach((e, i) => {
          let data = [];
          timeMarks.forEach(t => {
            let elem = e.jobSearchTermsPerWeek.filter(kpw => kpw.week === t.week && kpw.year === t.year);
            if (elem.length > 0) {
              data.push(elem[0].count);
            } else {
              data.push(0);
            }
          });

          datasets.push({
            label: e._id,
            data: data,
            backgroundColor: jobOffersColors[i]
          });

        });

        const labels = timeMarks.map(e => `week ${e.week}`);

        return {labels, datasets};
      },
    },
    mounted(){
      this.groupedBarChartData = this.composeGroupedBarChartData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/jobOffersPerWeekBars.vue